import React, {
  useState,
  useContext,
  useEffect
} from 'react';

import PropTypes from 'prop-types';

import {
  checkInputValidity
} from 'src/Utility/utility';

import {
  SalesContext
} from 'src/Context/SalesContext';

import VettingDropDown from 'src/Components/Common/VettingDropDown/VettingDropDown';

import VettingInput from 'src/Components/Common/VettingInput/VettingInput';

import {
  FormFieldLabel
} from 'src/StyledComponents';

import {
  provinces
} from 'src/Common/constants';

import './AnotherAddress.css';

const AnotherAddress = (props) => {
  const context = useContext(SalesContext);

  const [ formData, setFormData ] = useState({
    formComponents: {
      unitNumber: {
        name: 'Unit number ',
        type: 'input',
        value: context.deliveryAddress.unitNumber || '',
        width: 30,
        optional: true,
        validations: {
          required: false,
          maxLength: 5,
          invalidMessage: 'Please enter a valid unit number'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: '#'
        },
        isValid: true,
        isTouched: false
      },
      buildingName: {
        name: 'Complex/building name ',
        type: 'input',
        value: context.deliveryAddress.buildingName || '',
        width: 70,
        optional: true,
        validations: {
          required: false
        },
        config: {
          type: 'text',
          required: true,
          maxLength: 30,
          placeholder: 'Enter complex/building name'
        },
        isValid: true,
        isTouched: false
      },
      streetAddress: {
        name: '*Street address',
        type: 'input',
        value: context.deliveryAddress.streetAddress || '',
        width: 100,
        validations: {
          required: true,
          minLength: 1,
          invalidMessage: 'Please enter a valid street address'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Enter street address'
        },
        isValid: false,
        isTouched: false
      },
      suburb: {
        name: '*Suburb',
        type: 'input',
        value: context.deliveryAddress.suburb || '',
        width: 70,
        validations: {
          required: true,
          invalidMessage: 'Please enter a valid suburb'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Enter suburb'
        },
        isValid: false,
        isTouched: false
      },
      postalCode: {
        name: '*Postal code',
        type: 'input',
        value: context.deliveryAddress.postalCode || '',
        width: 30,
        validations: {
          required: true,
          type: 'number',
          minLength: 4,
          maxLength: 5,
          invalidMessage: 'Please enter a valid postal code'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: '#'
        },
        isValid: false,
        isTouched: false
      },
      city: {
        name: '*City',
        type: 'input',
        value: context.deliveryAddress.city || '',
        width: 70,
        validations: {
          required: true,
          invalidMessage: 'Please enter a valid city'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Enter town/city'
        },
        isValid: false,
        isTouched: false
      },
      province: {
        name: '*Province',
        type: 'dropDown',
        value: context.deliveryAddress.province || '',
        width: 30,
        validations: {
          required: true,
          invalidMessage: 'Please enter a valid province'
        },
        config: {
          type: 'text',
          required: true,
          options: [],
          placeholder: '- Select -'
        },
        isValid: false,
        isTouched: false
      }
    },
    isFormValid: false
  });

  const formCompArray = [];
  for (let key in formData.formComponents) {
    formCompArray.push({
      key: key,
      config: formData.formComponents[key]
    });
  }

  const formComponentChangeHandler = (value, inputIdentifier) => {
    const formCompsCopy = { ...formData.formComponents };
    const changedComponent = { ...formCompsCopy[inputIdentifier] };
    changedComponent.value =value;
    if (inputIdentifier === 'postalCode' || inputIdentifier === 'unitNumber') {
      changedComponent.value = value.trim();
    } else {
      changedComponent.value = value;
    }
    if (changedComponent.validations.type === 'number') {
      let lastChar = changedComponent.value.slice(-1);
      if (isNaN(lastChar)) {
        return false;
      }
    }
    changedComponent.isValid = checkInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    context.setDeliveryAddress({ key: inputIdentifier, value: changedComponent.value });

    changedComponent.isTouched = true;

    const newFormComps = {
      ...formCompsCopy,
      [inputIdentifier]: changedComponent
    };

    const isFormValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;
    if (isFormValid) {
      props.enableNext(true);
    } else {
      props.enableNext(false);
    }

    setFormData({
      formComponents: newFormComps,
      isFormValid: isFormValid
    });
  };

  useEffect(() => {
    const prevData = context.deliveryAddress;
    const formCompsCopy = { ...formData.formComponents };
    for (let key in prevData) {
      if (prevData[key] === '') {
        continue;
      }

      const changedComponent = { ...formCompsCopy[key] };
      changedComponent.value = prevData[key];

      changedComponent.isValid = checkInputValidity(
        changedComponent.value,
        changedComponent.validations
      );

      changedComponent.isTouched = true;

      formCompsCopy[key] = changedComponent;
    }

    const isFormValid = !Object.keys(formCompsCopy).find(e => formCompsCopy[e].isValid === false) ? true : false;

    if (isFormValid) {
      props.enableNext(true);
    } else {
      props.enableNext(false);
    }

    const changedComponent = { ...formCompsCopy['province'] };
    changedComponent.config.options = provinces;
    formCompsCopy['province'] = changedComponent;

    setFormData({
      formComponents: formCompsCopy,
      isFormValid: isFormValid
    });

  }, []);

  return (
    <div className="same-address-wrapper">
      {
        formCompArray.map((item, index) => {
          return (
            <div className={`delivery-field-wrapper-${ item?.config?.width }`} key={index}>
              <FormFieldLabel>
                {item.config.name}
                {
                  item?.config?.optional && <span className="vetting-optional-text"> (Optional)</span>
                }
              </FormFieldLabel>

              {
                item.config.type === 'input' &&
                  <VettingInput
                    {...item.config}
                    inputIdentifier={item.key}
                    updateValue={(value) => formComponentChangeHandler(value, item.key)}
                  />
              }
              {
                item.config.type === 'dropDown' &&
                  <VettingDropDown
                    {...item.config}
                    selectedValue={item.config?.value}
                    placeholder={item.config?.config?.placeholder}
                    options={item.config.config.options}
                    updateSelectedOption={(option) => formComponentChangeHandler(option, item.key)}
                  />
              }
            </div>
          );
        })
      }
    </div>
  );
};

AnotherAddress.propTypes = {
  enableNext: PropTypes.func
};

export default AnotherAddress;